import React from "react";
import { Card, Text, Anchor, CardProps, Group } from "@mantine/core";
import { ContactFields } from "../../types/contact.types";
import { UserFields } from "../../types/user.types";
import UserAvatar from "../UserAvatar";

interface ContactProps {
  contact: ContactFields | UserFields;
  cardProps?: CardProps;
  withBorder?: boolean;
}

export default function Contact({
  contact,
  cardProps,
  withBorder = true
}: ContactProps) {
  const { name, email, department } = contact;
  let displayName = name;

  if (!name && 'username' in contact)
    displayName = contact.username;
  
  return (
    <Card
      {...cardProps}
      shadow={withBorder ? "none" : "sm"}
      withBorder={withBorder}
    >
      <Group wrap="nowrap">
        <UserAvatar user={contact} size="lg" />
        <div>
          <Text fw={500}>{displayName}</Text>
          <Text size="sm" c="gray.7">{department}</Text>
          <Text size="sm">
            <Anchor href={`mailto:${email}`}>{email}</Anchor>
          </Text>
        </div>
      </Group>
    </Card>
  );
}
